import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ProgressDialog from "js/react/components/Dialogs/ProgressDialog";

async function withProgressDialog<T = any>({
    title,
    message,
    action,
}: {
    /**
     * Title of the dialog
     */
    title?: string;
    /**
     * Message of the dialog
     */
    message?: string;
    /**
     * Action to perform, setProgress expects the progress to be a number between 0 and 1
     */
    action: (props: { setProgress: (progress: number) => void, setMessage: (message: string) => void, setTitle: (title: string) => void }) => Promise<T>;
}) {
    const dialog = ShowDialog(ProgressDialog, {
        title,
        message,
    });

    const setProgress = (progress: number) => {
        dialog.setProgress(Math.min(Math.max(progress, 0), 1) * 100);
    };

    const setMessage = (message: string) => {
        dialog.setMessage(message);
    };

    const setTitle = (title: string) => {
        dialog.setTitle(title);
    };

    try {
        return await action({ setProgress, setMessage, setTitle });
    } finally {
        dialog.close();
    }
}

export default withProgressDialog;
